import { createGlobalStyle } from 'styled-components';

import colors from './colors';

const GlobalStyle = createGlobalStyle`
  /* Default */
  :root {
    --toastify-icon-color-success: #00ff07;
    --toastify-color-progress-success: #0ee214;
    --toastify-icon-color-error :#fff;
    --toastify-color-progress-error: #ff0000;
  }
  * {
    box-sizing: border-box;
    margin: 0;
    outline: 0;
    padding: 0;
  }
  html {
    overflow: hidden;
    height: 100%;
  }
  body {
    background-color: ${colors.background};
    text-rendering: optimizeLegibility !important;
    -webkit-font-smoothing: antialiased !important;
    overflow: auto;
    height: 100%;
  }
  body, input, textarea {
    font-family: 'Ubuntu', sans-serif !important;
  }
  a, button {
    outline: none;
    cursor: pointer;
  }

  a {
    font-weight: bolder;
    &:hover {
      color: skyblue;
    }
  }

  /* Toast Notification */
  .toast-notification-error,
  .toast-notification-info,
  .toast-notification-success,
  .toast-notification-warning {
    display:flex;
    .toast-notification-body {
      padding: 10px;
      font-size: 14px;
      color: ${colors.lighter};
      &:before {
        display: block;
        font-weight: bold;
        margin-bottom: 5px;
      }
    }
  }
  .toast-notification-error {
    background-color: ${colors.error};
  }
  .toast-notification-info {
    background-color: ${colors.info};
  }
  .toast-notification-success {
    background-color: ${colors.success};
  }
  .toast-notification-warning {
    background-color: ${colors.warning};
  }
  .main-dialog {
    top: 5%;
    @media (max-width: 576px) {
      width: 90%!important;
    }
  }

  .rc-dialog {
    margin: 0 auto!important;
  }

  .rc-dialog-body {
    padding: 0px;
    overflow-y: auto;
    @media (max-width: 1366px) {
      height: 650px;
    }
  }

  .rc-dialog-header{
    color: #ffffff!important;
    background-color: #14131a;

  }
  .rc-dialog-content{
    background-color: #14131a;
  }
  .rc-dialog-close {
    color: #ffffff;
    opacity: 1;
  }
  .block-dialog{
    top:5%;
    width: 850px!important;
    margin-bottom: 30px!important;
    @media (max-width: 1280px){
      width: 750px !important;
    }
    @media (max-width:1024px){
      width: 90%!important;
      top:5%;

    }
  }
`;

export default GlobalStyle;
